import { keyframes } from '@emotion/react';

export const pulse = (scale = 2) => keyframes`
  0% {
		opacity: 1;
	}
	75% {
		transform: scale(${scale});
		opacity: 0;
	}
	100% {
    transform: scale(${scale});
		opacity: 0;
	}
`;

export const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;
